import Alpine from "alpinejs";

import "../../../../JvMTECH.Components/Resources/Private/Main";
import "./CleverReach/CleverReach.js";
import "../Fusion/Prototypes/LazyContent/LazyContent";

if (!window.Alpine) {
    window.Alpine = Alpine;
}
Alpine.start();

if (process.env.NODE_ENV == "development") {
    console.log("JvMTECH.Base Main.js loaded");
}
